import React from 'react';
import '../Styles/Styles.scss';
function StatCard({ label, value, extra }) {
  return (
    <div className='stat-card'>
      <div className='stat-card__label'>
        {label}
        {extra && <span className='stat-card__extra'> {extra}</span>}
      </div>
      <div className='stat-card__value'>
        {isNaN(value) ? value : Number(value).toLocaleString()}
      </div>
    </div>
  );
}

export default StatCard;
